import { useI18n } from '../i18n';
import { Reveal } from './Reveal';

export function About() {
  const { t } = useI18n();
  return (
    <section class="summary" id="about">
      <div class="container">
        <div class="summary-grid">
          <div>
            <Reveal class="section-label" as="div">
              {t('about.label')}
            </Reveal>
            <Reveal as="h2" class="title" delay={1}>
              {t('about.title_a')} <em>{t('about.title_b')}</em>
              <br />
              {t('about.title_c')}
            </Reveal>
          </div>
          <div>
            <Reveal as="p" delay={1}>
              <strong>{t('about.p1_strong')}</strong> {t('about.p1')}
            </Reveal>
            <Reveal as="p" delay={2}>
              {t('about.p2')}
            </Reveal>

            <div class="features">
              <Reveal class="feat" delay={2}>
                <div class="feat-dot" />
                <div>
                  <h4>{t('about.features.predict_title')}</h4>
                  <p>{t('about.features.predict_body')}</p>
                </div>
              </Reveal>
              <Reveal class="feat" delay={3}>
                <div class="feat-dot" />
                <div>
                  <h4>{t('about.features.prizes_title')}</h4>
                  <p>{t('about.features.prizes_body')}</p>
                </div>
              </Reveal>
              <Reveal class="feat" delay={4}>
                <div class="feat-dot" />
                <div>
                  <h4>{t('about.features.free_title')}</h4>
                  <p>{t('about.features.free_body')}</p>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
